import $ from 'jquery';
import axios from "axios";

$(function () {
    const completedStageStatus = $('.tutorial-section').data('complete-text');// ?? 'Mark stage completed';
    const incompleteStageStatus = $('.tutorial-section').data('incomplete-text');// ?? 'Mark stage as incomplete';
    const allCompletedStageStatus = $('.tutorial-section').data('all-complete-text');// ?? 'Mark all stage completed';
    const allIncompleteStageStatus = $('.tutorial-section').data('all-incomplete-text');// ?? 'Mark all stage as incomplete';
    const readStageStatus = $('.tutorial-section').data('read-text');// ?? 'Mark stage completed';
    const inReadStageStatus = $('.tutorial-section').data('inread-text');// ?? 'Mark stage as incomplete';

    const changeStageButton = (element) => {
        $(document).on('click', element, function () {
            const url = $(this).data('url');
            const lessonCardId = $(this).data('lesson-card-id');
            const stageParent = $(this).parents('.stage');
            const isTheory = $(this).data('is-theory');

            if (!$(this).is('.stage-button--completed')) {
                axios.post(url, {lessonCardId: lessonCardId, mark: true})
                    .then((response) => {
                        $(this).html(isTheory ? inReadStageStatus : incompleteStageStatus);
                        $(this).addClass('stage-button--completed');

                        const index = stageParent.index('.stage') + 1;

                        if ($('.stage:eq(' + index + ')').length > 0) {
                            $('body,html').animate({'scrollTop': $('.stage:eq(' + index + ')').offset().top - $('#header').height()}, 1000);
                            // window.scrollTo({top: $('.stage:eq(' + index + ')').offset().top - $('#header').height()});
                        }

                        stageParent.append('<div class="done done--size-2"></div>');

                        $('a[href="#' + stageParent.attr('id') + '"]').parent().addClass('left-menu__item--completed');

                        if ($('.stage__button').length === $('.stage-button--completed').length) {
                            $('.all-stages').addClass('stage__button--completed');
                            $('.all-stages__text').html(allIncompleteStageStatus);
                        }
                    }).catch((error) => {
                    if (error.response.status === 401) {
                        if ($(this).data('redirect') !== undefined) {
                            window.location.href = $(this).data('redirect');

                            return;
                        }
                    }
                });
            } else {
                axios.post(url, {lessonCardId: lessonCardId, mark: false})
                    .then((response) => {
                        $(this).html(isTheory ? readStageStatus : completedStageStatus);
                        $(this).removeClass('stage-button--completed');
                        stageParent.find('div.done').remove();

                        $('a[href="#' + stageParent.attr('id') + '"]').parent().removeClass('left-menu__item--completed');

                        if ($('.stage__button').length !== $('.stage-button--completed').length) {
                            $('.all-stages').removeClass('stage__button--completed');
                            $('.all-stages__text').html(allCompletedStageStatus);
                        }
                    }).catch((error) => {
                    if (error.response.status === 401) {
                        if ($(this).data('redirect') !== undefined) {
                            window.location.href = $(this).data('redirect');

                            return;
                        }
                    }
                });
            }
        });
    };

    changeStageButton('.stage__button');

    $(document).on('click', '.all-stages', function () {
        const url = $(this).data('url');
        const lessonId = $(this).data('lesson-id');
        const buttons = $('.stages-list').find('.stage__button');
        const leftMenuItems = $('.left-menu__list').find('.left-menu__item');
        const stage = $('.stage');

        if (!$(this).is('.stage__button--completed')) {
            axios.post(url, {lessonId: lessonId, mark: true})
                .then((response) => {
                    $(this).addClass('stage__button--completed');
                    leftMenuItems.addClass('left-menu__item--completed');
                    buttons.addClass('stage-button--completed');
                    buttons.html(incompleteStageStatus);
                    $('.all-stages__text').html(incompleteStageStatus);
                    stage.append('<div class="done done--size-2"></div>');
                }).catch((error) => {
                if (error.response.status === 401) {
                    if ($(this).data('redirect') !== undefined) {
                        window.location.href = $(this).data('redirect');

                        return;
                    }
                }
            });
        } else {
            axios.post(url, {lessonId: lessonId, mark: false})
                .then((response) => {
                    $(this).removeClass('stage__button--completed');
                    leftMenuItems.removeClass('left-menu__item--completed');
                    buttons.removeClass('stage-button--completed');
                    buttons.html(completedStageStatus);
                    $('.all-stages__text').html(completedStageStatus);
                    stage.find('div.done').remove();
                }).catch((error) => {
                if (error.response.status === 401) {
                    if ($(this).data('redirect') !== undefined) {
                        window.location.href = $(this).data('redirect');

                        return;
                    }
                }
            });
        }
    });
});
